import type { Market } from "@/entities/robot";

/**
 * Выбранный фильтр каталога, переживающий уход на карточку робота.
 *
 * Почему не URL. Фильтр — состояние экрана, а не адрес: по ТЗ переключение
 * обязано обходиться без смены route, и остальные фильтры проекта (период
 * графика, лента активности) живут по тому же правилу. Почему не `useState`
 * страницы: она размонтируется при переходе в карточку, и возврат назад
 * сбрасывал бы выбор — человек, отсмотревший Futures, возвращался в «Все».
 *
 * Почему `sessionStorage`, а не переменная модуля: вкладку Telegram WebView
 * перезагружает при каждом открытии мини-аппа, и переменная всё равно не
 * пережила бы больше, чем сессию, — зато глобал протёк бы между тестами.
 *
 * Доступ к storage обёрнут: в WebView с запрещёнными куками само обращение к
 * `sessionStorage` бросает, а каталог обязан открыться в любом случае.
 */
export type MarketFilterValue = Market | "all";

export const DEFAULT_MARKET_FILTER: MarketFilterValue = "all";

const KEY = "catalog:market";
const ALLOWED: readonly MarketFilterValue[] = ["all", "spot", "futures"];

export function readMarketFilter(): MarketFilterValue {
  try {
    const stored = sessionStorage.getItem(KEY);
    // Чужое значение из storage (старая версия, ручная правка) — это «все», а
    // не пустой экран: неизвестный рынок не совпадёт ни с одним роботом.
    return ALLOWED.find((value) => value === stored) ?? DEFAULT_MARKET_FILTER;
  } catch {
    return DEFAULT_MARKET_FILTER;
  }
}

export function writeMarketFilter(value: MarketFilterValue): void {
  try {
    sessionStorage.setItem(KEY, value);
  } catch {
    // Фильтр не переживёт переход — экран от этого не ломается.
  }
}
